module.exports = __webpack_public_path__ + "img/m-hd.c7e4c4dd.webp";